import { render } from "./ModalUploadFile.vue?vue&type=template&id=4f108cc5&scoped=true"
import script from "./ModalUploadFile.vue?vue&type=script&lang=js"
export * from "./ModalUploadFile.vue?vue&type=script&lang=js"

import "./ModalUploadFile.vue?vue&type=style&index=0&id=4f108cc5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f108cc5"]])

export default __exports__